"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressChangePriceOutputWidget = void 0;
var React = require("react");
var PremiumOutputWidget_1 = require("../subscription/PremiumOutputWidget");
var commonFunctions_1 = require("../../commonFunctions");
var IPTDisclamer_1 = require("../../components/IPTDisclamer");
var components_1 = require("@athena-portal/components");
var AddressChangePriceOutputWidget = /** @class */ (function (_super) {
    __extends(AddressChangePriceOutputWidget, _super);
    function AddressChangePriceOutputWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.amountToDisplay = function () {
            var neverHigherAmount = (0, commonFunctions_1.getNeverHigherPeriodAmount)(_this.props.interaction);
            var neverHigherAmountWording = (0, commonFunctions_1.getNeverHigherPeriodWording)(_this.props.interaction, neverHigherAmount, _this.state.policies);
            var priceExplanationSection = React.createElement(React.Fragment, null,
                React.createElement("p", { className: "mb-0" }, "to change your address."),
                React.createElement("p", { className: "text-center mx-4 mb-0" }, "Your price could go up or down, but we guarantee you won't pay more than"),
                React.createElement("p", { className: "text-center font-weight-bold mx-4" }, neverHigherAmountWording));
            var _a = _this.props.interaction.factors, returnPremium = _a.returnPremium, additionalPremium = _a.additionalPremium;
            var displayMessage;
            if (additionalPremium && additionalPremium > 0) {
                window.sessionStorage.setItem("additionalPremium", additionalPremium);
                displayMessage = React.createElement(React.Fragment, null,
                    React.createElement("p", { id: "price", className: "price-address-change" }, (0, commonFunctions_1.getAmountToDisplay)(additionalPremium)),
                    priceExplanationSection,
                    React.createElement(IPTDisclamer_1.default, { cssClass: "text-center mx-4 mb-0" }));
            }
            else if (returnPremium && returnPremium > 0) {
                window.sessionStorage.setItem("returnPremium", returnPremium);
                displayMessage = React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "font-weight-bold" }, "Refund of"),
                    React.createElement("p", { id: "price", className: "price-address-change" }, (0, commonFunctions_1.getAmountToDisplay)(returnPremium)),
                    priceExplanationSection,
                    React.createElement(IPTDisclamer_1.default, { cssClass: "text-center mx-4 mb-0" }));
            }
            else {
                displayMessage = React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "font-weight-bold" }, "There is no extra cost"),
                    priceExplanationSection,
                    React.createElement(IPTDisclamer_1.default, { cssClass: "text-center mx-4 mb-0" }));
            }
            return displayMessage;
        };
        return _this;
    }
    AddressChangePriceOutputWidget.prototype.render = function () {
        if (this.state.subscription && this.state.policies) {
            return (React.createElement("div", { className: "panel text-center" }, this.amountToDisplay()));
        }
        else {
            return React.createElement(components_1.Overlay, { show: true });
        }
    };
    return AddressChangePriceOutputWidget;
}(PremiumOutputWidget_1.PremiumOutputWidget));
exports.AddressChangePriceOutputWidget = AddressChangePriceOutputWidget;
//# sourceMappingURL=AddressChangePriceOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/falconSelfService/AddressChangePriceOutputWidget.js
// module id = 3269
// module chunks = 0